export function resolvePromiseWithResolvers<T>(p: PromiseWithResolvers<T>, cb: () => Promise<T>) {
  return cb()
    .then(result => {
      p.resolve(result)
    })
    .catch(error => {
      p.reject(error)
    })
    .then(() => {
      return p.promise
    })
}
